module.exports = __webpack_public_path__ + "img/icon-download-white.30770a4d.svg";